import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section-title" }
const _hoisted_2 = { class: "title-text" }
const _hoisted_3 = {
  key: 0,
  class: "required"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_PulseTooltip = _resolveComponent("PulseTooltip")
  const _component_Divider = _resolveComponent("Divider")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString($props.title.toUpperCase()), 1 /* TEXT */),
    ($props.required)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
      : _createCommentVNode("v-if", true),
    (!!$options.tt_data && !_ctx.$responsive.mobile)
      ? (_openBlock(), _createBlock(_component_PulseTooltip, {
          key: 1,
          class: "tooltip",
          title: $options.tt_title,
          content: $options.tt_content,
          "popper-options": {modifiers: [{name: 'offset', options: { offset: [50, 6] }}]}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, {
              size: "1.6rem",
              icon: "circle-help",
              stroke: "var(--brand-400)"
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title", "content"]))
      : _createCommentVNode("v-if", true),
    ($props.line)
      ? (_openBlock(), _createBlock(_component_Divider, {
          key: 2,
          class: "divider",
          m: "0"
        }))
      : _createCommentVNode("v-if", true)
  ]))
}